import {isWeaveObjectRef, parseRef, type WeaveObjectRef} from '../react';

const PROTOCOL = 'weave://';

export const makeRefCall = (
  entity: string,
  project: string,
  callId: string
): string => {
  return `${PROTOCOL}/${entity}/${project}/call/${callId}`;
};

export const makeRefAgentTurn = (
  entity: string,
  project: string,
  traceId: string
): string => {
  return `${PROTOCOL}/${entity}/${project}/agent_turn/${traceId}`;
};

export const makeRefAgentConversation = (
  entity: string,
  project: string,
  conversationId: string
): string => {
  return `${PROTOCOL}/${entity}/${project}/agent_conversation/${encodeURIComponent(conversationId)}`;
};

export const makeRefAgentSpan = (
  entity: string,
  project: string,
  spanId: string
): string => {
  return `${PROTOCOL}/${entity}/${project}/agent_span/${spanId}`;
};

export const makeRefObject = (
  entity: string,
  project: string,
  objectType: string,
  objectId: string,
  objectVersion: string,
  refExtra: string | undefined
): string => {
  let ref = `${PROTOCOL}/${entity}/${project}/${objectType}/${objectId}:${objectVersion}`;
  if (refExtra) {
    ref += `/${refExtra}`;
  }
  return ref;
};

// Parse a weave ref string to its object ref, or null if it isn't one.
export const parseWeaveObjectRef = (ref: string): WeaveObjectRef | null => {
  try {
    const parsed = parseRef(ref);
    return isWeaveObjectRef(parsed) ? parsed : null;
  } catch {
    return null;
  }
};

// Inverse of makeRefAgentTurn: the turn trace_id for an agent_turn ref, else null.
export const traceIdFromAgentTurnRef = (ref: string): string | null => {
  const parsed = parseWeaveObjectRef(ref);
  return parsed?.weaveKind === 'agent_turn' ? parsed.artifactName : null;
};

export const abbreviateRef = (ref: string): string => {
  return PROTOCOL + '/...' + ref.slice(-6);
};
